import styled from "@emotion/styled";

import { ThemeMode } from "../../context/ThemeContext";

export const AppCheckboxWrapper = styled.label<{ mode?: ThemeMode }>`
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  align-items: center;
  position: relative;
  input {
    position: absolute;
    width: 100%;
    height: 100%;
    visibility: hidden;
    opacity: 0;
    margin: 0;
    padding: 0;
  }
  div {
    flex-grow: 0;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${({ mode }) => (mode === "dark" ? "#3A4255" : "#E2E8F0")};
    border-radius: 4px;
    width: 24px;
    height: 24px;
    box-sizing: border-box;
    transition: all 0.3s ease;
    margin-right: 11px;
  }
  svg {
    transition: all 0.3s ease;
    font-size: 20px;
    color: transparent;
    opacity: 0;
  }
  input:checked ~ div {
    background: ${({ mode }) => (mode === "dark" ? "#236BCF" : "#1A509B")};
    svg {
      color: #f0f0f0;
      opacity: 1;
    }
  }
  .label {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: ${({ mode }) => (mode === "dark" ? "#F0F0F0" : "#0D0A2C")};
    user-select: none;
  }
`;
